import { render, staticRenderFns } from "./AudioNoticeboardList.vue?vue&type=template&id=026112b8&"
import script from "./AudioNoticeboardList.vue?vue&type=script&lang=js&"
export * from "./AudioNoticeboardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports